module.exports = __webpack_public_path__ + "img/logo-white.0f601d6c.svg";